var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-0.00012207 14.8571H11.9999V13.1428H-0.00012207V14.8571ZM11.9999 5.4285H8.57131V0.285645H3.42845V5.4285H-0.00012207L5.99988 11.4285L11.9999 5.4285Z",
    fill: "#888281"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownload);
export default __webpack_public_path__ + "static/media/arrow-download.3e8e95327c6aa0a9102a5a74e42c424c.svg";
export { ForwardRef as ReactComponent };